'use strict';

module.exports = /* @ngInject */ function () {
    return {
        template: '<ul class="list-group"> \
  						<li class="list-group-item list-group-item-{{inventory.availabilityClass}} pointer" ng-click="showInventory()">' + gettxt.inventory.availability + '</li> \
  						<li class="list-group-item" ng-repeat="item in inventory.items"> \
  							{{item.location.code}} {{item.warehouse.code}} {{item.storagePlace.code}} \
  							<span class="badge">{{item.quantity}}</span> \
  						</li> \
  					</ul>'
    }
}
